import NanoEvents from 'nanoevents';
import unbindAll from 'nanoevents/unbind-all';
import { consoleLog, emptyLog } from './loggers';

export default class WebRTCBase {
  constructor(url, opts = {}, shouldLog = false) {
    this.url = url;
    this.emitter = new NanoEvents();
    this.notify = this.emitter.emit.bind(this.emitter);
    this.log = shouldLog ? consoleLog : emptyLog;

    this.isFirstMsgReceived = false;

    this.retryMax = opts.retryMax || 1;
    this.retryDelay = opts.retryDelay || 3000;
    this.retryCounter = this.retryMax;
    this.stopRetryTimeout = null;
    this.connectionTimeout = null;
  }

  static get version() {
    try {
      // eslint-disable-next-line no-undef
      return webrtc_version || '';
    } catch {
      return '';
    }
  }

  destroy() {
    clearTimeout(this.stopRetryTimeout);
    clearTimeout(this.connectionTimeout);

    unbindAll(this.emitter);
    if (typeof this.onDestroy === 'function') {
      this.onDestroy();
    }
  }

  /**
   * Used to stop only after retries limit exceeded
   * @param {function} cb
   */
  stopRetry(cb) {
    this.isFirstMsgReceived = false;
    this.retryCounter -= 1;
    if (this.retryCounter > 0) {
      clearTimeout(this.stopRetryTimeout);
      this.stopRetryTimeout = setTimeout(cb.bind(this), this.retryDelay);
    } else {
      this.stop();
    }
  }

  /**
   * Do this for all method, that should be implemented in descendants
   */
  stop() {
    this.shouldImplementError('stop');
  }

  retryCounterReset() {
    this.retryCounter = this.retryMax;
  }

  /**
   *
   * @param {array} args
   * @param {string} args[0] - event name
   * @param {function} args[1] - callback for event
   * @returns {*}
   */
  on(...args) {
    const { on } = this.emitter;
    return on.apply(this.emitter, args);
  }

  shouldImplementError(name) {
    return () => {
      throw new Error(
        `Custom ${name} method should be implemented for WebRTCBase descendants`,
      );
    };
  }

  getVideoCardInfo() {
    const gl = typeof document !== 'undefined' && document.createElement('canvas').getContext('webgl');
    if (!gl) {
      return '';
    }
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    return debugInfo
      ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      : 'no WEBGL_debug_renderer_info';
  }
}
